module.exports = __webpack_public_path__ + "static/media/CSPORT TAT2M2 TURNTABLE.ff4ce413.png";